module.exports = __webpack_public_path__ + "static/buildup_img1-717b88f586b53779c5cef8b647f2baf1.gif";